import { render, staticRenderFns } from "./MessengerSelect.vue?vue&type=template&id=3adca0fc&scoped=true&"
import script from "./MessengerSelect.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MessengerSelect.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MessengerSelect.vue?vue&type=style&index=0&id=3adca0fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adca0fc",
  null
  
)

export default component.exports